import { CLIENT_SIDE_STRIPE_ERROR } from '@app/common/src/components/PlanPurchaseExperience/constants'
import { ClientSideError, ClientSideErrorType } from '@dtx-company/logger'
import { Stripe } from '@stripe/stripe-js'
import { fireAnalyticsEvent } from '@dtx-company/inter-app/src/event-tracking/helpers/fireAnalyticsEvent'
import { handlePaymentIntentSetupIntentErrors } from '@app/common/src/components/PlanPurchaseExperience/utils/handlePaymentIntentSetupIntentErrors'

export const additionalPaymentSetupIntentVerification = async (
  stripe: Stripe,
  clientSecret: string,
  nextActionType?: string
): Promise<void> => {
  // handling ach bank payments - need to verify with microdeposits
  if (nextActionType == 'verify_with_microdeposits') {
    const verifiedResult = await stripe.verifyMicrodepositsForPayment(clientSecret, {
      amounts: [32, 45]
    })
    await handlePaymentIntentSetupIntentErrors({
      paymentError: verifiedResult.error,
      paymentIntent: verifiedResult.paymentIntent,
      setupIntent: undefined
    })
  } else {
    // not sure what will cause this so logging for now
    fireAnalyticsEvent('Payment_Action_Cancelled', {
      actionType: nextActionType,
      value: 'Action was cancelled'
    })
    throw new ClientSideError({
      message: 'Action was cancelled',
      name: CLIENT_SIDE_STRIPE_ERROR,
      type: ClientSideErrorType.ClientSideValidationError
    })
  }
}
